var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayCarat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "19px",
    viewBox: "0 0 12 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ERW---HiddenMyNotifications",
    transform: "translate(-509.000000, -495.000000)",
    fill: "#999999",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(40.000000, 333.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dates",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "July-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "item-2",
    transform: "translate(22.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.214138,34 C447.913289,34 447.590952,33.8894303 447.354571,33.6461769 C446.88181,33.1596702 446.88181,32.3856823 447.354571,31.8991755 L455.498963,24.4958777 L447.354571,17.1146939 C446.88181,16.6281872 446.88181,15.8541992 447.354571,15.3676925 C447.827333,14.8811858 448.579453,14.8811858 449.052215,15.3455786 L458.056173,23.6113201 C458.292554,23.8545734 458.4,24.1641686 458.4,24.4958777 C458.4,24.8275869 458.271065,25.1371821 458.056173,25.3804354 L449.052215,33.6461769 C448.815834,33.8894303 448.514986,34 448.214138,34 Z",
    id: "Path"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCarat);
export default __webpack_public_path__ + "static/media/GrayCarat.a3d1b8af7ededf2577f75d49534cbc93.svg";
export { ForwardRef as ReactComponent };